export const defaultTimeForStart = '07:00';
export const defaultTimeForEnd = '20:00';
